import React, { useEffect, useState } from "react";
import useCoreAgoraCheck from "../../../../general/customHooks/coreAgoraCheck";
import { ExclamationTriangle } from "react-bootstrap-icons";
import VideoPlayerThum from "../../../../general/components/VideoUser/VideoPlayerThum";
import VideoControl from "../molekuls/VideoControl";
import useDataSession from "../../../SessionMethodVideoModul/customeHooks/useDataSession";
import {
  unixTime,
  unixToDayDDMMMMYYYY,
} from "../../../../general/functions/datetimeFunction";
import { useDispatch, useSelector } from "react-redux";
import { SetJoinRoom } from "../../actions/waitingRoomActions";
import { GetUsersWaiting } from "../../actions/usersWaitingRoomActions";
import { GetAssessorGuide } from "../../../SessionMethodVideoModul/actions/guideActions";

const dataShow = [
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
  {
    name: "KhiBar",
    email: "test@test.com",
    picAva: "https://flowbite.com/docs/images/people/profile-picture-5.jpg",
    type: "ASSESSEE",
  },
];
const LOREMIPSUM =
  "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not know how to pursue pleasure rationally encounter consequences that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain of itself, because it is pain, but because occasionally circumstances occur in which toil and pain can procure him some great pleasure. To take a trivial example, which of us ever undertakes laborious physical exercise, except to obtain some advantage from it? But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a pain that produces no resultant pleasure?";

export default function AssessorView() {
  const {
    isSelfTracksReady,
    selfTracks,
    isMuteTrackSelf,
    setMuteSelfTracks,
    error,
  } = useCoreAgoraCheck();
  const [listUserInWaiting, setListUserInWaiting] = useState([]);
  const { dataSession } = useDataSession();
  const [textData, setTextData] = useState({ assessor: "", assessee: "" });

  const dispatch = useDispatch();
  // dataSession?.user?.email
  const storeWSUsers = useSelector((state) => state.wsmodul_users_waiting);

  useEffect(() => {
    dispatch(GetUsersWaiting());
  }, []);

  const storeGetGuide = useSelector((state) => state.smvm_get_assessor_guide);
  useEffect(() => {
    if (dataSession?.sessionInfo?.mehodId != undefined) {
      dispatch(GetAssessorGuide(dataSession?.sessionInfo?.mehodId));
    }
  }, [dataSession?.sessionInfo?.mehodId]);

  useEffect(() => {
    if (storeGetGuide.success) {
      let data = {
        assessor: storeGetGuide.data?.guidelineAssessor,
        assessee: storeGetGuide.data?.guidelineAssessee,
      };
      setTextData(data);
    }
  }, [storeGetGuide]);

  useEffect(() => {
    if (storeWSUsers.success) {
      console.log(
        "user waiting room aeffect",
        storeWSUsers.data,
        dataSession?.user?.email
      );
      setListUserInWaiting(
        storeWSUsers?.data?.filter((x) => x?.email != dataSession?.user?.email)
      );
    }
  }, [storeWSUsers]);

  const handleStartSession = () => {
    dispatch(SetJoinRoom());
  };
  return (
    <div className="flex justify-center items-center h-screen bg-gray-50 ">
      <div className="flex flex-col  w-full items-center justify-center p-2 gap-4 ">
        <div className="flex  max-w-4xl w-full border rounded-md bg-white ">
          {isSelfTracksReady && (
            <>
              <div className="w-full aspect-video  relative">
                <VideoPlayerThum
                  videoTrack={selfTracks[1]}
                  isVideoMute={!isMuteTrackSelf?.video}
                  isMicMute={!isMuteTrackSelf?.audio}
                  title={"Name User"}
                  uid={"userSelf?.uId"}
                  isSpeak={false}
                />
                <div className="absolute bottom-2 w-full flex justify-center">
                  <VideoControl
                    setMute={(v) => {
                      setMuteSelfTracks(v?.type, v?.status);
                    }}
                    tracksState={isMuteTrackSelf}
                  />
                </div>
              </div>
            </>
          )}
          {isSelfTracksReady == false && error == null && (
            <div className="w-full aspect-video max-w-md relative flex flex-col items-center justify-center gap-2 bg-gray-800 rounded-md">
              <label className="font-medium text-sm text-white">
                Compatibility check...
              </label>
            </div>
          )}
          {error != null && (
            <div className="w-full aspect-video max-w-md relative flex flex-col items-center justify-center gap-2 bg-gray-800 rounded-md">
              <ExclamationTriangle size={32} className="text-white" />
              <label className="font-medium text-sm text-white">{error}</label>
            </div>
          )}

          <div className="max-w-md w-full  p-4 flex flex-col items-start relative">
            <p className=" w-full text-left text-sm font-bold text-gray-600">
              Waiting Room | {dataSession?.sessionInfo?.methodName}
            </p>
            <h1 className="text-3xl text-primary-500 font-bold leading-tight ">
              {dataSession?.sessionInfo?.sessionTitle}
            </h1>
            <p className="text-sm text-secondary-500 leading-5">Scheduled:</p>
            {dataSession?.sessionInfo?.startTime != undefined && (
              <p className="font-medium text-left text-sm text-secondary-500 leading-5">
                {" " + unixToDayDDMMMMYYYY(dataSession?.sessionInfo?.startTime)}
                <br />
                {" " + unixTime(dataSession?.sessionInfo?.startTime)}
              </p>
            )}
            <p className="text-sm text-secondary-500 leading-5">
              Join As Assessor
            </p>
            <div className="mt-2">
              <button
                className="btn-primary"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  handleStartSession();
                }}
                // disabled={loading}
              >
                Start Session
              </button>
            </div>
          </div>
        </div>
        {/* {error != null && (
          <div className="bg-yellow-400 rounded-md m-2 font-medium text-sm px-4 py-2">
            {error}
          </div>
        )} */}

        {/*  */}
        <div class="max-w-4xl w-full flex rounded-md border shadow-md">
          <div className="max-w-xl w-4/5  p-4 flex flex-col items-start">
            <p className="border-b w-full text-left text-sm font-bold text-gray-600">
              Assessor Guides
            </p>
            <div className="max-h-60 overflow-auto w-full">
              {textData.assessor == null || textData.assessor == "" ? (
                <div className="flex justify-center items-center max-h-60 h-64 w-full ">
                  <p className="text-gray-500">No data available</p>
                </div>
              ) : (
                <div
                  className="ql-container ql-snow "
                  style={{ border: "0px" }}
                >
                  <div
                    className="ql-editor "
                    style={{
                      minHeight: "initial",
                      padding: "0px 10px 0px 0px",
                      maxHeight: "initial",
                    }}
                  >
                    <div
                      style={{ minHeight: "60px" }}
                      dangerouslySetInnerHTML={{
                        __html: textData.assessor,
                      }}
                    />
                  </div>
                </div>
              )}
              {/* <p className="text-justify pr-2">{{textData.assessor}}</p> */}
            </div>
          </div>
          <div class="p-4 bg-white w-3/5 ">
            <div class="flex justify-between items-center  ">
              <p className="border-b w-full text-left text-sm font-bold text-gray-600">
                People in the waiting room
              </p>
            </div>

            {listUserInWaiting?.length > 0 ? (
              <div class="flow-root px-4 overflow-auto max-h-60" style={{}}>
                <ul role="list" class="divide-y divide-gray-200  ">
                  {listUserInWaiting?.map((x, i) => {
                    return (
                      <li class="py-2 sm:py-2">
                        <div class="flex items-center space-x-4">
                          <div class="flex-shrink-0">
                            <img
                              class="w-8 h-8 rounded-full"
                              src={x.pictureUrl}
                              alt="Neil image"
                            />
                          </div>
                          <div class="flex-1 min-w-0 text-left">
                            <p class="text-sm font-medium text-gray-900 truncate ">
                              {x.name}
                            </p>
                            <p class="text-sm text-gray-500 truncate ">
                              {x.type} | {x.email}
                            </p>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : (
              <div className="flex justify-center items-center max-h-60 h-full w-full">
                <p className="text-gray-500">No data available</p>
              </div>
            )}
          </div>
        </div>
        {/*  */}
      </div>
    </div>
  );
}
